import { jsx as _jsx } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import parse, { attributesToProps, domToReactChildren, } from '@hellodarwin/core/lib/features/helpers/parse';
import { useMemo } from 'react';
import { useGinSteps } from '../../../../gin-steps-provider';
export const useParsedGinRichText = ({ richText, itemId, }) => {
    const { customRichTextParseOptions } = useGinSteps();
    const isValidTextContent = (content) => {
        var _a;
        const invalidValues = ['', '<p><br></p>', '<p></p>'];
        return ((_a = content === null || content === void 0 ? void 0 : content.trim()) === null || _a === void 0 ? void 0 : _a.length) && !invalidValues.includes(content === null || content === void 0 ? void 0 : content.trim());
    };
    const parseOptions = useMemo(() => ({
        replace: (domNode) => {
            if (domNode.attribs && domNode.name === 'a') {
                const props = attributesToProps(domNode.attribs);
                return (_jsx("a", Object.assign({}, props, { rel: "nofollow", target: "_blank", children: domToReactChildren(domNode.children) })));
            }
            if (domNode.attribs && domNode.name === 'p') {
                return (_jsx(Typography, { elementTheme: "body2", children: domToReactChildren(domNode.children) }));
            }
            if (domNode.attribs && domNode.name === 'li') {
                return (_jsx("li", { children: _jsx(Typography, { elementTheme: "body2", children: domToReactChildren(domNode.children) }) }));
            }
        },
    }), []);
    const processedContent = useMemo(() => {
        var _a;
        if (!richText)
            return '';
        const rawContent = (_a = richText === null || richText === void 0 ? void 0 : richText.replace(/&nbsp;/g, ' ')) !== null && _a !== void 0 ? _a : '';
        if (!isValidTextContent(rawContent))
            return '';
        if (customRichTextParseOptions && itemId) {
            return parse(rawContent, customRichTextParseOptions(itemId));
        }
        return parse(rawContent, parseOptions);
    }, [richText, customRichTextParseOptions, parseOptions, itemId]);
    return processedContent;
};
